import { createContext } from "react";

import { SegmentedControlSegmentProps } from "../SegmentedControlSegment";
import { SegmentedControlProps } from "../SegmentedControl";

/**
 * Context props for SegmentedControl internal state management
 */
export type SegmentedControlContextProps = {
  /**
   * Currently selected segment value
   */
  current?: SegmentedControlSegmentProps["value"];
  /**
   * Function to set the current segment
   */
  setCurrent?: (value: SegmentedControlSegmentProps["value"]) => void;
  /**
   * Change handler for the segmented control
   */
  onChange?: SegmentedControlProps["onChange"];
  /**
   * Name attribute for radio inputs
   */
  name?: string;
};

export const SegmentedControlContext =
  createContext<SegmentedControlContextProps>({});
